import { useState, createContext, useEffect } from 'react';
import { ConConfig } from '../../Models/Config';
import { semaforo } from '../../Utiles/Semaforo';
export interface DolarType {
    tasa: number,
    banco: number,
}
export const DolarContext = createContext<DolarType>({ tasa: 1, banco: 1 })
export default function DolarProvider({ children }: { children: any }) {
    const [tasa, setDolar] = useState(1);
    const [banco, setBanco] = useState(1);
    const s = semaforo();
    const update = () => {
        if (s.isTurn('Dolares')) {
            ConConfig('').forceGetWeb('/api/Dolares/valor', ([dolar, banco2]) => {
                if (tasa !== dolar) setDolar(dolar);
                if (banco !== banco2) setBanco(banco2);
                s.next();
            });
        }
    }
    let interval: any;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { interval = setInterval(update, 100); return () => clearInterval(interval); }, [tasa])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { s.add('Dolares'); return () => s.clean('Dolares'); }, [])
    return <DolarContext.Provider value={{ tasa, banco }}>{children}</DolarContext.Provider>
}
export const SeccionConsumer = DolarContext.Consumer;